import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import adminApi from "../../api/adminApi";

const FIELD_SX = {
  "& .MuiInputBase-root": {
    height: 40,
  },
};

export default function ResetPasswordDialog({
  open,
  onClose,
  user,
  onSaved,
  setBanner,
}) {
  const [newPassword, setNewPassword] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setNewPassword("");
  }, [open]);

  const handleSave = async () => {
    if (!user?.email || !newPassword) return;

    setSaving(true);
    try {
      await adminApi.resetPassword({ email: user.email, newPassword });
      setBanner({ type: "success", text: `Password reset for ${user.email}` });
      onSaved?.();
      onClose?.();
    } catch (error) {
      setBanner({ type: "error", text: error.message || "Failed to reset password" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Reset password</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField
            label="Email"
            value={user?.email || ""}
            disabled
            fullWidth
            size="small"
            sx={FIELD_SX}
          />
          <TextField
            label="New password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            fullWidth
            autoFocus
            size="small"
            sx={FIELD_SX}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ height: 40 }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={saving || !newPassword}
          sx={{ height: 40, minWidth: 140 }}
        >
          {saving ? "Saving..." : "Reset password"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}